module.exports = __webpack_public_path__ + "static/SuisseIntl-184674961bf5fc30e7791292b42108ba.woff2";